export default "__VITE_ASSET__80b292cd__"